'use strict';

var _regeneratorRuntime = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncToGenerator = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var Block = require('ipld-block');

var CID = require('cids');

var multihash = require('multihashes');

var multipartRequest = require('../lib/multipart-request');

var configure = require('../lib/configure');

var toUrlSearchParams = require('../lib/to-url-search-params');

var abortSignal = require('../lib/abort-signal');

var _require = require('native-abort-controller'),
    AbortController = _require.AbortController;
/**
 * @typedef {import('../types').HTTPClientExtraOptions} HTTPClientExtraOptions
 * @typedef {import('ipfs-core-types/src/block').API<HTTPClientExtraOptions>} BlockAPI
 */


module.exports = configure(function (api) {
  /**
   * @type {BlockAPI["put"]}
   */
  function put(_x) {
    return _put.apply(this, arguments);
  }

  function _put() {
    _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
      var options,
          _multihash$decode,
          name,
          length,
          cid,
          _multihash$decode2,
          _name,
          _length,
          controller,
          signal,
          res,
          response,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

              if (Block.isBlock(data)) {
                _multihash$decode = multihash.decode(data.cid.multihash), name = _multihash$decode.name, length = _multihash$decode.length;
                options = _objectSpread(_objectSpread({}, options), {}, {
                  format: data.cid.codec,
                  mhtype: name,
                  mhlen: length,
                  version: data.cid.version
                }); // @ts-ignore - data is typed as block so TS complains about
                // Uint8Array assignment.

                data = data.data;
              } else if (options.cid) {
                cid = new CID(options.cid);
                _multihash$decode2 = multihash.decode(cid.multihash), _name = _multihash$decode2.name, _length = _multihash$decode2.length;
                options = _objectSpread(_objectSpread({}, options), {}, {
                  format: cid.codec,
                  mhtype: _name,
                  mhlen: _length,
                  version: cid.version
                });
                delete options.cid;
              } // allow aborting requests on body errors


              controller = new AbortController();
              signal = abortSignal(controller.signal, options.signal);
              _context.prev = 4;
              _context.t0 = api;
              _context.t1 = _objectSpread;
              _context.t2 = {
                timeout: options.timeout,
                signal: signal,
                searchParams: toUrlSearchParams(options)
              };
              _context.next = 10;
              return multipartRequest(data, controller, options.headers);

            case 10:
              _context.t3 = _context.sent;
              _context.t4 = (0, _context.t1)(_context.t2, _context.t3);
              _context.next = 14;
              return _context.t0.post.call(_context.t0, 'block/put', _context.t4);

            case 14:
              response = _context.sent;
              _context.next = 17;
              return response.json();

            case 17:
              res = _context.sent;
              _context.next = 29;
              break;

            case 20:
              _context.prev = 20;
              _context.t5 = _context["catch"](4);

              if (!(options.format === 'dag-pb')) {
                _context.next = 26;
                break;
              }

              return _context.abrupt("return", put(data, _objectSpread(_objectSpread({}, options), {}, {
                format: 'protobuf'
              })));

            case 26:
              if (!(options.format === 'dag-cbor')) {
                _context.next = 28;
                break;
              }

              return _context.abrupt("return", put(data, _objectSpread(_objectSpread({}, options), {}, {
                format: 'cbor'
              })));

            case 28:
              throw _context.t5;

            case 29:
              return _context.abrupt("return", new Block(
              /** @type {Uint8Array} */
              data, new CID(res.Key)));

            case 30:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 20]]);
    }));
    return _put.apply(this, arguments);
  }

  return put;
});